var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8265 0H1.09572C0.805118 0 0.526417 0.115893 0.320929 0.322183C0.115442 0.528473 0 0.808262 0 1.1V18.9C0 19.1917 0.115442 19.4715 0.320929 19.6778C0.526417 19.8841 0.805118 20 1.09572 20H10.6385V12.25H8.04857V9.25H10.6385V7C10.5848 6.47176 10.6469 5.93813 10.8205 5.43654C10.994 4.93495 11.2747 4.47755 11.643 4.09641C12.0113 3.71528 12.4581 3.41964 12.9522 3.23024C13.4464 3.04083 13.9758 2.96225 14.5034 3C15.2787 2.99521 16.0536 3.03528 16.8243 3.12V5.82H15.2405C13.9854 5.82 13.7463 6.42 13.7463 7.29V9.22H16.7346L16.3462 12.22H13.7463V20H18.8265C18.9704 20 19.1129 19.9715 19.2458 19.9163C19.3787 19.861 19.4995 19.78 19.6013 19.6778C19.703 19.5757 19.7837 19.4544 19.8388 19.321C19.8939 19.1875 19.9222 19.0445 19.9222 18.9V1.1C19.9222 0.955546 19.8939 0.812506 19.8388 0.679048C19.7837 0.54559 19.703 0.424327 19.6013 0.322183C19.4995 0.220038 19.3787 0.139013 19.2458 0.0837326C19.1129 0.0284524 18.9704 0 18.8265 0Z",
    fill: "#FFFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e88e1e9767d1dd15d87bb5359cabd9cc.svg";
export { ForwardRef as ReactComponent };